import React from 'react';
import { useAuthStore } from '../../stores/authStore';
import { buildStaticUrl } from '../../services/supportApi';

interface SidebarProps {
  unread: number;
  onContact: () => void;
  onOpenProfile: () => void;
}

/**
 * 左侧竖向 Sidebar。
 * 视觉自上而下：品牌标识（顶部）...（弹性留白）... 头像、Contact us、Logout（底部）。
 * 交互顺序按用户要求：从左下角往上依次是 Logout、Contact us、头像。
 */
export const Sidebar: React.FC<SidebarProps> = ({ unread, onContact, onOpenProfile }) => {
  const { user, logout } = useAuthStore();
  const avatar = user?.avatar_url ? buildStaticUrl(user.avatar_url) : '';
  const initial = (user?.nickname || 'U').charAt(0).toUpperCase();

  return (
    <aside className="w-20 shrink-0 bg-white border-r border-primary-100 flex flex-col items-center py-5">
      {/* 顶部品牌 */}
      <img
        src="/logo.jfif"
        alt="Logo"
        className="w-[70px] h-[70px] rounded-2xl object-contain object-center shadow-sm"
      />

      <div className="flex-1" />

      {/* 底部：头像 → Contact us → Logout（视觉从上到下） */}
      <div className="flex flex-col items-center gap-4">
        {/* 头像 */}
        <button
          onClick={onOpenProfile}
          title="Profile"
          className="group flex flex-col items-center gap-1"
        >
          {avatar ? (
            <img
              src={avatar}
              alt="Avatar"
              className="w-11 h-11 rounded-full object-cover ring-2 ring-primary-200 group-hover:ring-primary-400 transition"
            />
          ) : (
            <div className="w-11 h-11 rounded-full bg-primary-100 text-primary-700 flex items-center justify-center font-semibold ring-2 ring-primary-200 group-hover:ring-primary-400 transition">
              {initial}
            </div>
          )}
        </button>

        {/* Contact us */}
        <button
          onClick={onContact}
          title="Contact us"
          className="relative w-11 h-11 rounded-xl hover:bg-primary-50 flex items-center justify-center transition"
        >
          <img src="/talk.jfif" alt="Contact us" className="w-11 h-11 rounded-xl object-cover" />
          {unread > 0 && (
            <span className="absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 rounded-full bg-red-500 text-white text-[10px] leading-[18px] text-center">
              {unread > 99 ? '99+' : unread}
            </span>
          )}
        </button>

        {/* Logout */}
        <button
          onClick={logout}
          title="Logout"
          className="w-11 h-11 rounded-xl hover:bg-red-50 flex items-center justify-center transition"
        >
          <img src="/logout.jfif" alt="Logout" className="w-11 h-11 rounded-xl object-cover" />
        </button>
      </div>
    </aside>
  );
};
